import { Currency } from "src/app/services/response-models/currency.model";

export class SetCurrency {
    public static readonly type = "[App] Set currency";

    constructor(public payload: Currency) {}
}
